<template lang="pug">
  .folleto-b

    h1 {{ c[0].text }}
    
    .dere
      p.fo {{ c[1].text }}

    .tars

      .tar
        .morado
        img(:src="c[2].url")
        h2 {{ c[3].text }}
        p {{ c[4].text }}
        
      .tar
        .morado
        img(:src="c[5].url")
        h2 {{ c[6].text }}
        p {{ c[7].text }}

      .tar
        .morado
        img(:src="c[8].url") 
        h2 {{ c[9].text }}
        p {{ c[10].text }}

      .tar
        .morado
        img(:src="c[11].url")
        h2 {{ c[12].text }}
        p {{ c[13].text }}

      .tar
        .morado
        img(:src="c[14].url")
        h2 {{ c[15].text }}
        p {{ c[16].text }}

      .tar
        .morado
        h2 {{ c[17].text }}
        p {{ c[18].text }}
    
    .abajo
      h3.mas {{ c[19].text }}
      img(:src="c[20].url").celu
      p.fo {{ c[21].text }}
      img(:src="c[22].url").rnm


  
</template>
<script>
  export default {
    name: 'Folleto1',
    data() {
      return {
        c: {}
      }
    },
    methods: {
        getContent () {
        this.$prismic.client.getByUID("folleto", "folleto2")
          .then(response => {
            this.c = response.data.contenido
          });
        }
    },
    created() {
        this.getContent();
    }
  }
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@500&display=swap');

.folleto-b {
  background: #DCD1DC;
  padding: min(4vw, 60px) min(40px, 2vw);
  position: relative;
  border-radius: 16px;
}
.dere {
  display: flex;
  justify-content: flex-end;
  margin-bottom: min(60px, 5vw);
}
.dere > p {
  text-align: right;
  max-width: 880px;
  padding: 0;
  margin: 0;
  position: relative;
  right: 0;
}
.tars {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  grid-gap: 2.5em;
}
.tar {
  color: white;
  display: grid;
  grid-template-rows: 20px auto 30px auto auto;
  grid-template-columns: 1fr;
  text-align: center;
  justify-items: center;
}
.tar > .morado {
  background: #340043;
  border-radius: 14px;
  grid-row: 2 / span 4;
  grid-column: 1;
  padding: 0 1em 1em;
  justify-self: stretch;
}
.tar > img {
  max-width: 121%;
  max-height: 200px;
  grid-row: 1 / span 3;
  grid-column: 1;
}
.tar > h2 {
  background: #E1C3E6;
  color: #340043;
  padding: 0.2em .6em;
  grid-row: 3 / span 2;
  grid-column: 1;
  margin: 0;
  align-self: baseline;
  font-size: 1.3em;
}
.tar > p {
  grid-row: 5;
  grid-column: 1;
  padding: 0 1em .5em;
}


h1 {
  font-family: 'Oswald', sans-serif;
  font-size: calc(2em + 1vw);
  text-align: center;
  margin-bottom: min(60px, 5vw);
  line-height: 1.2em;
}
@supports (-webkit-text-stroke: 1px #340043) {
  h1 {
    -webkit-text-stroke: 1px #340043;
    -webkit-text-fill-color: #DCD1DC;
  }
}
.mas {
  margin-top: 80px;
  font-family: 'Oswald', sans-serif;
  font-weight: normal;
  background: #340043;
  font-weight: normal;
  color: white;
  font-style: italic;
  line-height: 2em;
  padding: 0 1em;
  width: 86%;
}
.fo {
  font-size: 1.2em;
}
.abajo {
  display: grid;
  grid-template-columns: 2.5fr 1fr;
}
.abajo > h3 {
  grid-column: 1 / span 2;
  grid-row: 1;
  align-self: baseline;
  font-size: calc(0.8em + 1vw);
  letter-spacing: max(-2px, 0);
}
.abajo > .celu {
  grid-row: 1;
  grid-column: 2;
  margin-top: -22px;
  width: 20vw;
  max-width: 321px;
}
.abajo > .rnm {
  justify-self: end;
  align-self: end;
}
@media only screen and (max-width: 650px) {
  .abajo {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .abajo > h3 {
    width: 100%;
  }
  .abajo > .rnm {
    align-self: flex-end;
  }
}

</style>